import { AfterViewInit, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from './../../../auth/auth.service';
import {UtilsService} from '../../../services/utils.service';
import Swal from "sweetalert2";
import {ConfigurationService} from '../../../services/configuration.service';
import {Router, NavigationEnd} from "@angular/router";
import {environment} from "../../../../environments/environment";
import { filter } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-appheader',
  templateUrl: './appheader.component.html',
  styleUrls: ['./appheader.component.css']
})
export class AppheaderComponent implements OnInit, AfterViewInit {

  @Input() userLogged: boolean;

  dataUser    : any;
  email: any;
  placeId: string;
  rolId: any;
  rolName: any;
  userInfo:any;
  isMenuVisible: boolean = true; // Variable para controlar la visibilidad del menú
  
  constructor(private auth: AuthService,
              private router: Router,
              private utilsService: UtilsService,
              private configService: ConfigurationService,
              private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.email = localStorage.getItem('email')
    this.placeId = environment.placeId;
    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    // console.log(this.userInfo.rol)

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Verificar la ruta actual
      const currentRoute = event.urlAfterRedirects;
      if(currentRoute.startsWith('/trainer/rutinas/') || currentRoute.startsWith('/trainer/guias/')){
        this.isMenuVisible = false;
      }
      else{
        this.isMenuVisible = true;
      }
    });
  }

  ngAfterViewInit() {
    this.collapseMenu();
  }

  collapseMenu() {
    const checkInterval = setInterval(() => {
      const barsButton = document.getElementById('menu1');
      if (barsButton) {
        barsButton.click();
        clearInterval(checkInterval);
      }
    }, 50); // Check every 100ms
  }

  onLogout() {
    this.auth.logout();
  }
}
